import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { snakeCase } from 'lodash';

import Input from 'components/inputs/input/Input';
import { FormField } from 'components/form';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { resetCustomizedField } from 'modules/subcampaigns/reducers/bulkOffer';

import { __t, applyTranslations } from 'utils/language';
import { isBulkOfferFieldCustomized } from 'utils/bulk-offer';

import './bulk-offer-customized-form-field.scss';

import type { SubcampaignBulkOfferStore, SubcampaignCreateBulkOfferCustomField } from 'types';

applyTranslations(require('./bulk-offer-customized-form-field.i18n.json'));

type OwnProps = {
  formFieldProps: Partial<React.ComponentProps<typeof FormField>>,
  fieldName: SubcampaignCreateBulkOfferCustomField,
  isBulkOfferActive: boolean,
  children: React.ReactNode
};

type StateProps = {
  bulkOfferStore: SubcampaignBulkOfferStore
};

type DispatchProps = {
  dispatchResetCustomizedField: (a: SubcampaignCreateBulkOfferCustomField) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const CUSTOM_PROPS: Record<string, Partial<React.ComponentProps<typeof Input>>> = {
  budget: {
    hint: '€',
    hintAlign: 'right'
  },
  legalRequirements: {},
  personalMessage: {}
};

class BulkOfferCustomizedFormField extends React.PureComponent<Props> {
  handleReset = () => {
    const { fieldName, dispatchResetCustomizedField } = this.props;

    dispatchResetCustomizedField(fieldName);
  };

  render() {
    const { formFieldProps, fieldName, children, bulkOfferStore, isBulkOfferActive } = this.props;
    const isCustomized = isBulkOfferActive && isBulkOfferFieldCustomized(fieldName, bulkOfferStore);

    if (isCustomized) {
      const isCustomizedFully = isBulkOfferFieldCustomized(fieldName, bulkOfferStore, true);
      const inputClasses = classnames({
        'bulk-offer-customized-form-field__input': true,
        'bulk-offer-customized-form-field__input--invalid': !isCustomizedFully,
        [`bulk-offer-customized-form-field__input--${snakeCase(fieldName).replace('_', '-')}`]: fieldName
      });

      return (
        <div className="bulk-offer-customized-form-field">
          <FormField
            {...formFieldProps}
            immediateValidationError={!isCustomizedFully ? __t('bulk_offer_customized_form_field.field_customized_invalid') : ''}
          >
            <div className="bulk-offer-customized-form-field__field">
              <div className={inputClasses}>
                <Input
                  disabled
                  value={__t('bulk_offer_customized_form_field.field_customized')}
                  width="responsive"
                  {...CUSTOM_PROPS[fieldName]}
                />
              </div>
              <div className="bulk-offer-customized-form-field__reset">
                <Tooltip
                  width="normal"
                  display="flex"
                  message={__t('bulk_offer_customized_form_field.button_reset_tooltip')}
                >
                  <SVGDynamicIcon
                    name="rotate-left-custom-fg"
                    width={24}
                    height={24}
                    customColor="grey"
                    onClick={this.handleReset}
                  />
                </Tooltip>
              </div>
            </div>
          </FormField>
        </div>
      );
    }

    return children;
  }
}

const mapStateToProps = ({ bulkOffer }): StateProps => ({
  bulkOfferStore: bulkOffer
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchResetCustomizedField: (fieldName) => dispatch(resetCustomizedField(fieldName))
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkOfferCustomizedFormField);
